import React from 'react';

const ToggleSwitch = ({ checked, onChange }) => (
  <label style={{ position: 'relative', display: 'inline-block', width: '48px', height: '24px' }}>
    <input type="checkbox" checked={checked} onChange={onChange} style={{ opacity: 0, width: 0, height: 0 }} />
    <span style={{ position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0, background: checked ? '#10b981' : '#ccc', transition: '.4s', borderRadius: '24px' }}>
      <span style={{ position: 'absolute', height: '18px', width: '18px', left: checked ? '26px' : '3px', bottom: '3px', background: 'white', transition: '.4s', borderRadius: '50%' }}></span>
    </span>
  </label>
);

const getVehicleIcon = (type) => {
  const icons = { bike: '🏍️', car: '🚗', truck: '🚛', van: '🚐' };
  return icons[type.toLowerCase()] || '🚚';
};

const getVehicleColor = (type) => {
  const colors = { bike: '#3b82f6', car: '#10b981', truck: '#ef4444', van: '#8b5cf6' };
  return colors[type.toLowerCase()] || '#6b7280';
};

const VehiclesTab = ({ vehicles, onAddVehicle, onRemoveVehicle, onToggleVehicle, onEditVehicle }) => (
  <div style={{ background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #f3f4f6' }}>
      <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', margin: 0 }}>Fleet Management</h3>
      <button onClick={onAddVehicle} style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>+ Add Vehicle</button>
    </div>
    <div style={{ display: 'grid', gap: '15px' }}>
      {vehicles.map(v => (
        <div key={v.id} style={{ padding: '12px', border: '2px solid #e5e7eb', borderRadius: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', opacity: v.status === 'unavailable' ? 0.6 : 1, borderLeft: `4px solid ${getVehicleColor(v.type)}` }}>
          <div style={{ flex: 1 }}>
            <h4 style={{ fontSize: '16px', color: getVehicleColor(v.type), margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
              {getVehicleIcon(v.type)} <span>{v.name}</span>
            </h4>
            <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
              <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Driver: {v.driver}</p>
              <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Type: {v.type}</p>
              <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Capacity: {v.capacity}kg</p>
            </div>
            <p style={{ fontSize: '13px', color: '#6b7280', margin: '5px 0 0 0' }}>📍 {v.location}</p>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>🌐 Lat: {v.coords[1]}, Long: {v.coords[0]}</p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}>
            <span style={{ color: v.status === 'available' ? '#10b981' : '#ef4444', fontWeight: 600 }}>● {v.status.charAt(0).toUpperCase() + v.status.slice(1)}</span>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <button onClick={() => onEditVehicle(v)} style={{ minWidth: '80px', padding: '6px 10px', background: '#fbbf24', color: 'black', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', transition: 'all 0.2s ease-in-out' }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                ✏️ Edit
              </button>
              <ToggleSwitch checked={v.status === 'available'} onChange={() => onToggleVehicle(v.id)} />
              <button onClick={() => onRemoveVehicle(v.id)} style={{ minWidth: '80px', padding: '6px 10px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', transition: 'all 0.2s ease-in-out' }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                🗑️ Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default VehiclesTab;
